import {
  BookIcon,
  Box,
  Popover,
  PopoverTrigger,
  Portal,
  useDisclosure,
} from "@hightouch/htui";
import { NavItem } from "src/components/layout/nav/nav-item";
import { navIcon } from "src/components/layout/nav/nav-icon";
import {
  NAV_POPOVER_MENU_ITEM_STYLES,
  NavPopoverContentAndBody,
  PopoverHeader,
} from "src/components/layout/nav/nav-popovers";
import type { UserMenuItemProps } from "src/components/layout/header/user-menu";
import { useResourceLinks } from "src/components/layout/nav/footer/resource-links";

const ResourcesIcon = navIcon(BookIcon);

/** The Resources row and its list, for the canvas's nav, which has no user menu to hold them. */
export const Resources = () => {
  const links = useResourceLinks();
  const { isOpen, onClose, onToggle } = useDisclosure();

  return (
    <Popover
      placement="right-start"
      offset={[0, 16]}
      isOpen={isOpen}
      onClose={onClose}
    >
      <PopoverTrigger>
        <NavItem
          isActive={isOpen}
          icon={ResourcesIcon}
          label="Resources"
          onClick={onToggle}
        />
      </PopoverTrigger>
      <Portal>
        <NavPopoverContentAndBody>
          <PopoverHeader title="Resources" />
          {links.map((link) => (
            // Picking a row closes the list, which sits in its own portal and outlives the nav closing around it.
            <MenuRow
              key={link.label}
              {...link}
              onClick={() => {
                onClose();
                link.onClick();
              }}
            />
          ))}
        </NavPopoverContentAndBody>
      </Portal>
    </Popover>
  );
};

const MenuRow = ({ icon: Icon, label, onClick, href }: UserMenuItemProps) => (
  <Box
    as={href ? "a" : "button"}
    {...(href ? { href, target: "_blank", rel: "noopener noreferrer" } : {})}
    display="flex"
    alignItems="center"
    gap={2}
    bg="white"
    color="text.primary"
    h={10}
    _hover={{ bg: "base.background" }}
    onClick={onClick}
    {...NAV_POPOVER_MENU_ITEM_STYLES}
  >
    <Box as={Icon} fontSize="lg" color="text.secondary" flexShrink={0} />
    {label}
  </Box>
);
